export * from './comissao.dto';
